import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router';
import { buttonClass, cx, type ButtonSize, type ButtonVariant } from './classes.js';

interface Shared {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  children: ReactNode;
}

/**
 * Controls (design v1): accent is spent on the ONE primary action per
 * screen; everything else is quiet. `primary` must appear once per screen.
 */
export function Button({
  variant = 'secondary',
  size = 'md',
  className,
  children,
  type = 'button',
  ...rest
}: Shared & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type={type} className={cx(buttonClass(variant, size), className)} {...rest}>
      {children}
    </button>
  );
}

export function ButtonLink({
  to,
  variant = 'secondary',
  size = 'md',
  className,
  children,
  state,
}: Shared & { to: string; state?: unknown }) {
  return (
    <Link to={to} state={state} className={cx(buttonClass(variant, size), className)}>
      {children}
    </Link>
  );
}

/** A plain anchor styled as a button (downloads, external links). */
export function ButtonAnchor({
  href,
  variant = 'secondary',
  size = 'md',
  className,
  children,
  download,
  onClick,
}: Shared & { href: string; download?: string; onClick?: () => void }) {
  return (
    <a
      href={href}
      download={download}
      onClick={onClick}
      className={cx(buttonClass(variant, size), className)}
    >
      {children}
    </a>
  );
}
